import { MdRefresh } from "react-icons/md";
import { IoClose } from "react-icons/io5";

const Notification = ({
  showNotification,
  handleCloseNotification,
  handleRefresh,
  isUpdating,
}) => {
  if (!showNotification) return null;

  return (
    <div className="fixed top-0 right-0 mx-auto max-w-md p-4 z-50 pointer-events-auto">
      <div className="bg-white border border-red-200 text-red-800 rounded-xl shadow-lg transition-all duration-300 ease-in-out transform translate-y-0 animate-slideIn backdrop-blur-sm bg-opacity-95">
        <div className="flex items-center justify-between p-4 border-b border-red-100">
          <div className="flex items-center space-x-3">
            <span className="text-2xl text-red-600" aria-hidden="true">
              ⚠️
            </span>
            <h4 className="text-base font-semibold tracking-tight">
              Account Inactive
            </h4>
          </div>
          <button
            onClick={handleCloseNotification}
            className="text-red-600 hover:text-red-800 focus:outline-none focus:ring-2 focus:ring-red-300 rounded-full p-1 transition-colors duration-200"
            aria-label="Close notification"
          >
            <IoClose size={20} />
          </button>
        </div>
        <div className="p-4">
          <p className="text-sm text-red-700 leading-relaxed">
            Please provide a valid API key or contact the system administrator.
            If the API key is already entered, refresh the database.
          </p>
          <div className="mt-3 flex items-center justify-end space-x-2">
            <button
              onClick={handleRefresh}
              className={`inline-flex items-center px-3 py-1.5 text-sm font-medium text-red-700 bg-red-50 hover:bg-red-100 rounded-md transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-red-300 ${
                isUpdating ? "animate-pulse" : ""
              }`}
              aria-label="Refresh database"
              disabled={isUpdating}
            >
              <MdRefresh
                className={`mr-1.5 ${isUpdating ? "animate-spin" : ""}`}
                size={18}
              />
              {isUpdating ? "Refreshing..." : "Refresh"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notification;
